import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader'; // eslint-disable-line
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import { RewriteFrames } from '@sentry/integrations';
import { version, sentry } from 'common/config/config';
import 'common/LoadServiceWorker';
import storeProvider from 'common/redux/storeProvider';
import configureStore from './redux/configureStore';
import Root from './Root';

storeProvider.init(configureStore);

Sentry.init({
  dsn: sentry.dsn,
  release: version.tagName,
  integrations: [new RewriteFrames()],
  environment: sentry.env,
});

Sentry.setTag('app', 'advertiser');

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={storeProvider.get()}>
        <Component />
      </Provider>
    </AppContainer>,
    document.querySelector('#app'),
  );
};

render(Root);


// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./Root', () => render(Root));
}



// WEBPACK FOOTER //
// ./src/advertisers/index.js